import React from 'react';

type ClaimsTableCellProps = {
  children: React.ReactNode;
  as?: React.ElementType;
  itemType: string;
};

function ClaimsTableCell({ children, as: Cell = 'td', itemType }: ClaimsTableCellProps) {
  return <Cell data-item-type={itemType}>{children}</Cell>;
}

export default ClaimsTableCell;
